import { render, staticRenderFns } from "./Confirmcao.vue?vue&type=template&id=3e8a0622&"
import script from "./Confirmcao.vue?vue&type=script&lang=js&"
export * from "./Confirmcao.vue?vue&type=script&lang=js&"
import style0 from "./Confirmcao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports